import { lazy, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { EditView, Props } from './EditView.tsx';

export const LazyEditView: LazyComponent<
	({
		reporterId,
		onChange,
		isDropdownMenuFixedAndLayered,
		isInvalid,
		autoFocus,
		openMenuOnFocus,
		value,
		classNamePrefix,
		onCloseMenuOnScroll,
		spacing,
		...fieldProps
	}: Props) => React.JSX.Element
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
> = lazy<typeof EditView>(() =>
	import(/* webpackChunkName: "async-jira-issue-field-entitlement-edit" */ './EditView.tsx').then(
		(module) => module.EditView,
	),
);
